import { ComponentType, SVGProps } from 'react'
import {
  MaxIcon,
  TelegramIcon,
  VKIcon,
  WhatsAppIcon,
} from '@/utils/icons'
import {
  AvitoIcon,
  CianIcon,
  InstagramIcon,
  ViberIcon,
} from '@/utils/icons/messengerBrandIcons'
import WazzupIcon from '@pages/Admin/CRM/components/PhoneIntegrationButtons/WazzupIcon'
import { getWazzupChannelTypeFamily } from './wazzupCrmIntegration.helpers'

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>

export type WazzupChannelTypeVisual = {
  Icon: IconComponent
  /** Акцент для фона кружка (монохромные иконки красятся через currentColor). */
  accentColor: string
  /**
   * Brand-mark со своими цветами/градиентами —
   * не форсировать fill: currentColor.
   */
  isBrandMark: boolean
}

const VISUAL_BY_FAMILY: Record<string, WazzupChannelTypeVisual> = {
  whatsapp: {
    Icon: WhatsAppIcon,
    accentColor: '#25D366',
    isBrandMark: false,
  },
  waba: {
    Icon: WhatsAppIcon,
    accentColor: '#25D366',
    isBrandMark: false,
  },
  telegram: {
    Icon: TelegramIcon,
    accentColor: '#2AABEE',
    isBrandMark: false,
  },
  max: {
    Icon: MaxIcon,
    accentColor: '#5B5CFF',
    isBrandMark: true,
  },
  vk: {
    Icon: VKIcon,
    accentColor: '#0077FF',
    isBrandMark: false,
  },
  viber: {
    Icon: ViberIcon,
    accentColor: '#7360F2',
    isBrandMark: true,
  },
  instagram: {
    Icon: InstagramIcon,
    accentColor: '#E1306C',
    isBrandMark: true,
  },
  avito: {
    Icon: AvitoIcon,
    accentColor: '#00AAFF',
    isBrandMark: true,
  },
  cian: {
    Icon: CianIcon,
    accentColor: '#0468FF',
    isBrandMark: true,
  },
}

const FALLBACK_VISUAL: WazzupChannelTypeVisual = {
  Icon: WazzupIcon,
  accentColor: 'var(--color-status-success-text)',
  isBrandMark: true,
}

/**
 * Иконка + акцент по `channel.type` Wazzup (whatsapp / tgapi / maxbot / …).
 */
export const getWazzupChannelTypeVisual = (
  type: string | null | undefined,
): WazzupChannelTypeVisual => {
  const normalized = String(type ?? '')
    .trim()
    .toLowerCase()
  if (!normalized) return FALLBACK_VISUAL

  if (normalized === 'waba') return VISUAL_BY_FAMILY.waba
  if (normalized === 'viber') return VISUAL_BY_FAMILY.viber
  if (normalized === 'instagram' || normalized === 'ig') {
    return VISUAL_BY_FAMILY.instagram
  }
  if (normalized === 'avito') return VISUAL_BY_FAMILY.avito
  if (normalized === 'cian' || normalized === 'cian.ru') {
    return VISUAL_BY_FAMILY.cian
  }

  const family = getWazzupChannelTypeFamily(normalized)
  return VISUAL_BY_FAMILY[family] ?? FALLBACK_VISUAL
}
